export default "__VITE_ASSET__cdf9b086__"